// extracted by mini-css-extract-plugin
module.exports = {"content_container":"InboundEmailTestPopup_content_container__2D9m6","icon":"InboundEmailTestPopup_icon__22zmp"};